import { Box, Modal, TextField, Typography, Autocomplete, Checkbox, Chip } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { Form, Formik } from "formik";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function AccessListModal({
  style,
  open,
  handleClose,
  ownerId,
  accessList,
  accessListOptions,
  handleChangeAccessList,
}) {
  const handleSubmit = (data) => {
    handleChangeAccessList(data.accessList);
    handleClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography variant="h4" sx={{ mb: "1rem" }}>
          Share Access
        </Typography>
        <Formik
          initialValues={{ accessList }}
          enableReinitialize
          validateOnChange
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <Autocomplete
                multiple
                options={accessListOptions}
                disableCloseOnSelect
                // limitTags={3}
                getOptionLabel={(option) => option.name}
                onChange={(_, value) =>
                  setFieldValue(
                    "accessList",
                    value.map((t) => t.id)
                  )
                }
                value={accessListOptions.filter((option) => values.accessList.includes(option.id))}
                sx={{
                  "span.MuiAutocomplete-tag": {
                    backgroundColor: "#fff",
                    color: "#000",
                  },
                  ".MuiChip-root": {
                    backgroundColor: "#333",
                  },
                  mt: "1rem",
                }}
                renderOption={(props, option, { selected }) => (
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      sx={{ mr: 1 }}
                      checked={selected}
                    />
                    {option.name}
                  </li>
                )}
                getOptionDisabled={(option) => option.id === ownerId}
                renderTags={(tagValue, getTagProps) =>
                  tagValue.map((option, index) => (
                    <Chip
                      label={option.name}
                      {...getTagProps({ index })}
                      disabled={option.id === ownerId}
                    />
                  ))
                }
                renderInput={(params) => <TextField {...params} label="Access List" />}
              />
              <MDBox mt={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <MDButton onClick={handleClose} color="gray80" style={{ marginRight: "10px" }}>
                  Cancel
                </MDButton>
                <MDButton type="submit" color="primaryRed">
                  Save
                </MDButton>
              </MDBox>
            </Form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

export default AccessListModal;
